import React from "react";
import { Button, Modal } from "antd";
import moment from 'moment';
import styles from "./index.less";

const PublishModal = (props) => {
  const { publishModalVisible, values, handleOk, handleCancel, loading, sendStatus } = props;
  const {
    senderName,
    msgSendSetting,
    isTiming,
    publishTimeString,
  } = values;

  const remindMessage = {
    1: "全部人员",
    2: "新增人员",
    3: "不提醒"
  };

  return (
    <Modal
      centered
      title="发布"
      visible={publishModalVisible}
      className={styles["publish-modal"]}
      width={650}
      maskClosable={false}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>取消</Button>,
        <Button loading={loading} type="primary" onClick={() => handleOk({ status: 1 })}>
          {sendStatus == '4' ? '确认发布' : isTiming !== 0 ? "确认保存" : "确认发布"}
        </Button>
      ]}
    >
      <div className="attribute">
        <div className="title">属性</div>
        <div className="attribute-container">
          <div className="attribute-item">
            <span>发布者：</span>
            <span>{senderName}</span>
          </div>
          <div className="attribute-item">
            <span>消息提醒：</span>
            <span>{remindMessage[msgSendSetting]}</span>
          </div>
          {
            sendStatus != '4' && <div className="attribute-item">
              <span>定时发送：</span>
              <span>
                {
                  isTiming == 0 ? <span>否</span> : <span>{moment(publishTimeString).format('YYYY.MM.DD HH:mm')}</span>
                }
              </span>
            </div>
          }
        </div>
      </div>
    </Modal>
  );
};

export default PublishModal;
